import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import EducationMaterialLibrary from './EducationMaterialLibrary';

loadDOMComponent({
	selector: 'react-education-material-library',
	callback: ({ container, context, props }) => {
		props = { ...props };
		props.savingButton = container.getAttribute('savingButton') !== null;
		props.afterSave = container.getAttribute('afterSave') ?? null;

		ReactDOM.render(
			<AppContextProvider {...context}>
				<EducationMaterialLibrary {...props} />
			</AppContextProvider>,
			container,
		);
	},
});
